import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import TextComponentReplace from "shared/text-component-replace"
import useCurrentCountry from "components/utils/use-current-country"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

/** @typedef {object} ComponentsUsersAcceptTermsHintProps */

/** @typedef {object} ComponentsUsersAcceptTermsHintState */

/**
 * @extends {ShapeComponent<ComponentsUsersAcceptTermsHintProps, ComponentsUsersAcceptTermsHintState>}
 */
class ComponentsUsersAcceptTermsHint extends ShapeComponent {
  render() {
    const {t} = useI18n({namespace: "js.components.users.accept_terms_hint"})
    const currentCountry = useCurrentCountry()
    let privacyLink, termsOfServiceLink

    if (currentCountry?.countryCode() == "US") {
      privacyLink = "https://planetwoof.io/us/privacy-policy/"
      termsOfServiceLink = "https://planetwoof.io/us/terms-and-conditions/"
    } else {
      privacyLink = t(".privacy_policy_link")
      termsOfServiceLink = t(".terms_of_service_link")
    }

    const replaces = [
      {
        component: (
          <a href={privacyLink} key="privacy-policy" target="_blank">
            {t(".privacy_policy")}
          </a>
        ),
        text: "%{privacy_policy}"
      },
      {
        component: (
          <a href={termsOfServiceLink} key="terms-of-service" target="_blank">
            {t(".terms_of_service")}
          </a>
        ),
        text: "%{terms_of_service}"
      }
    ]

    return (
      <TextComponentReplace
        replaces={replaces}
        text={t(".click_here_to_read_the_privacy_policy_and_terms_of_service")}
      />
    )
  }
}

export default memo(shapeComponent(ComponentsUsersAcceptTermsHint))
